import { EMyHomeActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const updateIsMyHomeExist = actionGenerator<EMyHomeActionTypes.UpdateIsExist, boolean>(
  EMyHomeActionTypes.UpdateIsExist,
);
